import React from 'react';
import { Button, Spin, Select, Modal, DatePicker } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';
import AttendanceTable from '../share/AttendanceTable';

const Option = Select.Option;
import moment from 'moment';
const { MonthPicker } = DatePicker;

export default class TeacherAttendanceStatisticsIndexPage extends React.Component {
  constructor(props) {
    super(props);
    let semester = SharedTools.getCurrentSemester(), currentRole = CurrentRoleStore.getCurrentRole();
    let semesters = SharedTools.getAllSemesters(semester, 20171);
    let columns = [
      { title: '姓名', dataIndex: 'full_name' },
      { title: '未到天数', dataIndex: 'absence_count' },
      { title: '迟到天数', dataIndex: 'late_count' },
      { title: '早退天数', dataIndex: 'leave_early_count' },
      { title: '操作', dataIndex: 'operation', render: (text, record) => <span className="header-operation" onClick={this.goNextPage.bind(this, record)}>查看</span>},
    ];

    this.state = {
      semester,
      currentRole,
      semesters,
      setAttendance: false,
      editAttendance: false,
      visible: false,
      loading: false,
      columns,
      teachers: [],
      schoolId: props.params.schoolId,
      setStatus: true,


      showAttendance: false,
      date: new Date()
    }

    this.selectSemester = this.selectSemester.bind(this)
    this.goSetCalendarPage = this.goSetCalendarPage.bind(this)
    this.callBack = this.callBack.bind(this)

  }

  componentDidMount() {
    this.getTeacherSumSet(this.state.semester)
    this.getTeachersAttendance(this.state.semester)
  }

  getTeacherSumSet(semester) {
    let data = {
      school_id: this.state.schoolId,
      semester: semester
    }
    DataService.getTeacherSumSet(data).then((res) => {
      this.setState({
        setStatus: res.setted > 0 ? true : false
      })
    }).catch((error) => {
      console.log(error)
    });
  }

  getTeachersAttendance(semester) {
    this.setState({
      loading: true
    })
    DataService.getTeacherStatistic({ school_id: this.state.schoolId, semester}).then(res => {
      this.setState({
        teachers: res,
        loading: false
      })

    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
      })
    })
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      })
      this.getTeachersAttendance(value)
      this.getTeacherSumSet(value)
    }
  }

  goNextPage(record) {
    hashHistory.push(`teacher-attendance/schools/${this.props.params.schoolId}/attendance-statistics/teachers/${record.id}?semester=${this.state.semester}`);
  }

  callBack() {

  }

  goSetCalendarPage() {
    hashHistory.push(`teacher-attendance/schools/${this.props.params.schoolId}/attendance-calendar`);
  }

  // 导出报告
  onChangeDate(date, dateString) {
    this.setState({
      date: dateString
    })
  }

  handleOk() {
    let year = moment(this.state.date).format('YYYY'), month = moment(this.state.date).format('MM');
    let root = `${window.location.protocol}//${window.location.host}/`;
    let url = `${root}api/v1/schools/teacher_clock_on_report?year=${year}&month=${month}&school_id=${this.state.schoolId}`
    window.open(url);
    this.setState({
      showAttendance: false
    })
  }

  disabledDate(current) {
    return current > moment().endOf('month');
  }

  _withoutAttendanceCalendarView() {
    return (
      <div className="without-attendance-calendar-view">
        <div className="view-header">请先完成老师考勤校历</div>
        <div className="view-label">查看考勤统计需要先去“老师考勤日历”页面设置本学期需要考勤的天数。</div>
        <Button type="primary" onClick={this.goSetCalendarPage}>去设置 老师考勤校历</Button>
      </div>
    )
  }

  render() {
    let { columns, teachers, loading, setStatus } = this.state;
    const monthFormat = 'YYYY-MM';
    return (
      <div className="student-attendance-statistics-index-page attendance-table-container">
        <div className="page-header">
                    老师考勤情况
          <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester} className="select-semester">
            {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
          </Select>
          {setStatus?<Button type="primary" style={{marginLeft:30 }}onClick={() => this.setState({ showAttendance: true })}>月度考勤报告导出</Button>:null}
          {setStatus ? 
            <AttendanceTable columns={columns} data={teachers} loading={loading} callBack={this.callBack} />
          : this._withoutAttendanceCalendarView()}
        </div>
        <Modal
          title="老师考勤月度报告"
          visible={this.state.showAttendance}
          onOk={this.handleOk.bind(this)}
          onCancel={() => this.setState({ showAttendance: false })}
          wrapClassName="export-attendance-modal"
          footer={[
            <Button key="submit" type="primary" loading={loading} onClick={this.handleOk.bind(this)}>
              确认导出
            </Button>,
          ]}
        >
          <MonthPicker format={monthFormat} onChange={this.onChangeDate.bind(this)} allowClear={false} disabledDate={this.disabledDate} defaultValue={moment(new Date())} />
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/TeacherAttendanceStatisticsIndexPage.jsx